<div class="lead-agenda-item" *ngIf="formControl.value?.ends_at">
  {{ 'market_discovery.lead.calendar-item.from' | translate }}
  {{ formControl.value.target_at | date : 'dd-MM-yyyy HH:mm' }}
  <br />
  {{ 'market_discovery.lead.calendar-item.to' | translate }} {{ formControl.value.ends_at | date : 'dd-MM-yyyy HH:mm' }}
</div>
